import { render, staticRenderFns } from "./pdfBlock.component.vue?vue&type=template&id=9ce85afa&scoped=true&"
import script from "./pdfBlock.component.vue?vue&type=script&lang=js&"
export * from "./pdfBlock.component.vue?vue&type=script&lang=js&"
import style0 from "./pdfBlock.component.vue?vue&type=style&index=0&id=9ce85afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce85afa",
  null
  
)

export default component.exports